import { CheckOutlined, ClockCircleOutlined, CloseOutlined } from '@ant-design/icons';

import { EApplicationStatus } from '@/api/endpoints/schools/schoolSelectionPanel';

export const CANDIDATE_STATUS_TO_TAG_SETTINGS = {
  [EApplicationStatus.Approved]: {
    text: 'Одобрено',
    color: 'green',
    icon: <CheckOutlined />,
  },
  [EApplicationStatus.Rejected]: {
    text: 'Отклонено',
    color: 'volcano',
    icon: <CloseOutlined />,
  },
  [EApplicationStatus.OnChecking]: {
    text: 'На проверке',
    color: 'gold',
    icon: <ClockCircleOutlined />,
  },
};
